import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Svg} from '@modifi/ui'

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
const defaultProps = {
  color: 'currentColor',
  width: 16,
  height: 16,
}

type DocumentProcessingIconProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const DocumentProcessingIcon: React.FC<DocumentProcessingIconProps> = ({color, ...props}) => (
  <Svg viewBox="0 0 49 49" color="#fff" {...props}>
    <path d="M40.582 15.4694L30.7222 5.60967L28.9295 4.41455L28.0332 5.60967L28.6308 16.3658L40.582 16.9633V15.4694Z" />
    <path
      d="M29.6042 4.08325H12.2501C11.1671 4.08325 10.1285 4.51346 9.36273 5.27923C8.59695 6.04501 8.16675 7.08362 8.16675 8.16659V40.8333C8.16675 41.9162 8.59695 42.9548 9.36273 43.7206C10.1285 44.4864 11.1671 44.9166 12.2501 44.9166H36.7501C37.833 44.9166 38.8716 44.4864 39.6374 43.7206C40.4032 42.9548 40.8334 41.9162 40.8334 40.8333V15.3124L29.6042 4.08325Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5833 4.08325V16.3332H40.8332"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6666 26.5417H16.3333"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6666 34.7083H16.3333"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4166 18.375H16.3333"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

DocumentProcessingIcon.propTypes = propTypes
DocumentProcessingIcon.defaultProps = defaultProps

export default DocumentProcessingIcon
